<template>
  <section class="content-block">
    <transition name="slide-fade">
      <div v-if="active" class="block has-white-background">

        <div v-if="eventSequence === '5' || eventSequence === '7'" class="inner-block">
          <h3 class="title">{{ $t(`startView.special.title`) }}</h3>
          <h3 class="title">{{ $t(`startView.special.subtitle`) }}</h3>
          <p class="subtitle">{{ $t(`startView.special.desc`) }}</p>
          <a class="button is-primary" @click="startReservationProcess(3)">
            {{ $t(`startView.special.button`) }}
            <i class="arrow right"/>
          </a>
        </div>
        <template v-else>
          <template v-for="i in 2"> <!-- set to 3 to enable reservation type #3 -->
            <template v-if="i > 1">
              <div class="marker" :key="'marker-'+i">
                <div class="line"/>
                <span class="subtitle">{{ $t("general.label.or") }}</span>
              </div>
            </template>
            <div class="inner-block" :key="'block-'+i">
              <h3 class="title">{{ $t(`startView.logic${i}.title`) }}</h3>
              <h3 class="title">{{ $t(`startView.logic${i}.subtitle`) }}</h3>
              <p class="subtitle">{{ $t(`startView.logic${i}.desc`) }}</p>
              <a class="button is-primary" @click="startReservationProcess(i)">
                {{ $t(`startView.logic${i}.button`) }}
                <i class="arrow right"/>
              </a>
            </div>
          </template>
        </template>

      </div>
    </transition>
  </section>
</template>

<script>
import {getURLParameter} from "../helper";

export default {
  name: 'Start',
  data() {
    return {
      active: false,
      showPurchaseButton: false,
      count: 0,
      eventSequence: null
    }
  },

  mounted() {

    // for testing:
    // http://localhost:8080/templates/dac/t1/module/reservation/?eventSequence=5 (=7)

    this.eventSequence = getURLParameter('eventSequence');
    this.active = true;
  },
  methods: {
    startReservationProcess(type) {
      this.$store.state.reservationType = type;
      this.goToPath('fahrt');
    },
    goToPath(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped lang="scss">
.marker {
  width: 100%;
  position: relative;
  display: block;
  text-align: center;
  padding-bottom: 1.6rem;

  .line {
    width: 100%;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }

  .subtitle {
    width: 100px;
    position: absolute;
    top: -0.55rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: block;
    color: rgba(180, 180, 180, 1);
    background-color: rgba(255, 255, 255, 1);
  }
}

@media (max-width: 680px) {
  .marker {
    .subtitle {
      top: -0.35rem;
    }
  }
}
</style>
